import Icon from "~/components/shared/Icon";
import CopyButton from "~/components/shared/CopyButton";

interface Props {
  branchName: string;
  branchPath: string;
  className?: string;
  mergeQueueBaseBranch: string | null;
  mergeQueuePath: string;
}

export function Branch({
  branchName,
  branchPath,
  className,
  mergeQueueBaseBranch,
  mergeQueuePath,
}: Props) {
  const metadata = mergeQueueBaseBranch
    ? {
        branchPath: mergeQueuePath,
        branchName: mergeQueueBaseBranch,
        icon: "custom/outline/14x/git-merge-queue",
      }
    : {
        branchPath,
        branchName,
        icon: "custom/outline/14x/branch",
      };

  const branchLink = (
    <a
      className="color-inherit hover-color-inherit flex min-w-0 items-center font-mono text-[90%]"
      href={metadata.branchPath}
    >
      <div className="mr-1 shrink-0">
        <Icon icon={metadata.icon} className="size-4 shrink-0 text-gray-800" />
      </div>
      <span className="max-w-full truncate" title={metadata.branchName}>
        {metadata.branchName}
      </span>
    </a>
  );

  if (Features.BuildSidebar) {
    return (
      <CopyButton
        title="Copy branch"
        overlay={true}
        iconOnly={true}
        size="xs"
        contentToCopy={metadata.branchName}
        className={className}
      >
        {branchLink}
      </CopyButton>
    );
  }

  return branchLink;
}
